import { render, staticRenderFns } from "./gr_asseverazioniPerArea.vue?vue&type=template&id=70c01069"
import script from "./gr_asseverazioniPerArea.vue?vue&type=script&lang=js"
export * from "./gr_asseverazioniPerArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports